<template>
  <div
    v-if="event && event.information.name && event.information.start_at"
    @click="handleClickViewEvent"
    class="w-full flex items-center justify-center gap-2 sticky cursor-pointer py-2 px-4 bg-app-primary hover:bg-app-secondary transition-colors duration-200"
  >
    <div
      class="flex items-center justify-center w-5 h-5 rounded-full bg-white/15 flex-shrink-0"
    >
      <CalendarIcon class="w-3 h-3 text-white" />
    </div>
    <div class="text-sm font-semibold text-white truncate">
      {{ event.information.name }}
    </div>
    <span class="text-white/40">·</span>
    <div class="text-sm text-white/80 flex-shrink-0">
      {{ dateFormat(event.information.start_at, "MMM D, h:mm A") }}
    </div>
    <ChevronRightIcon
      class="w-4 h-4 text-white/70 flex-shrink-0 ml-0.5"
    />
  </div>
</template>

<script setup>
import { CalendarIcon, ChevronRightIcon } from "@heroicons/vue/solid";
import { useRouter } from "vue-router";
import { onMounted, ref } from "vue";
import { dateFormat } from "@/helpers/date_formatter";
import { http } from "@/composable/httpService";
import { useEventBannerStore } from "@/stores/eventBanner.store";
import { storeToRefs } from "pinia";

const router = useRouter();
const eventBannerStore = useEventBannerStore();
const { event: eventBanner } = storeToRefs(eventBannerStore);
const event = ref(null);

const handleClickViewEvent = () => {
  router.push({ name: "event-detail-page", params: { id: event.value.id } });
};

const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

const getUpcomingEvent = async () => {
  const { data } = await http().get(
    `/v3/events/featured-event?timezone=${userTimeZone}`
  );
  event.value = data.data;
  eventBanner.value = data.data;
};

onMounted(() => {
  getUpcomingEvent();
});
</script>

<style lang="scss" scoped></style>
